export default "__VITE_ASSET__CNsTkixU__";